import { Texture } from "three";
import { IFsFileType } from "@/components/r3f-components/component-data-structure";
import { FsBaseFile } from "./base";

export type HlsPlaylistType = 'auto' | 'low' | 'high' | 'hd' | 'vr';

export class FsVideo extends FsBaseFile {
    type: IFsFileType.Video | IFsFileType.Video360 = IFsFileType.Video
    mp4Url: string
    thumbnailUrl: string

    protected _thumbnailTexture: Texture | undefined

    constructor(fileId: string, name: string) {
        super(fileId, name)
        if (this.id.startsWith('https://')) {
            this.baseUrl = this.id
        }
        const mp4Url = new URL(this.baseUrl)
        mp4Url.pathname = `${mp4Url.pathname}/video.mp4`
        this.mp4Url = mp4Url.toString()

        const thumbnailUrl = new URL(this.baseUrl)
        thumbnailUrl.pathname = `${thumbnailUrl.pathname}/frame0.png`
        this.thumbnailUrl = thumbnailUrl.toString()

        // const progressUrl = new URL(this.baseUrl)
        // progressUrl.pathname = `${progressUrl.pathname}/status.json`
        // this.progressUrl = progressUrl.toString()
    }

    getPlaylistUrl(type: HlsPlaylistType = 'auto') {
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/${type}.m3u8`
        return url.toString()
    }

    getMp4Url() {
        return this.mp4Url
    }

    getThumbnailUrl() {
        return this.thumbnailUrl
    }

    async load() {
        return this
    }
}
